export default {
    YES: "Подтвердить",
    NO: "Отмена"
};
